<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-6">
      <h2>{{ $t("navigations.subject profile") }}</h2>
    </div>
    <div class="col-lg-6 d-flex justify-content-end">
      <!-- <span class="position-relative cursor-pointer me-2" @click="openDocumetUploadModel">
              <img width="17" height="17" src="../../assets/img/create.png" alt="Edit" />
              <div class="tool-tip">Upload Consent Document</div>
            </span> -->
      <span
        v-if="subjectConsentForms.length != 0"
        class="position-relative cursor-pointer me-2"
        @click="openModelereconsent"
      >
        <img
          width="17"
          height="17"
          src="../../assets/img/start_e-consent.png"
          alt="Edit"
        />
        <div class="tool-tip">Start Re-Consent</div>
      </span>
      <!-- <span
        class="position-relative cursor-pointer me-2"
        @click="openModelconsentaudit"
      >
        <img
          width="17"
          height="17"
          src="../../assets/img/audit_trail_view.png"
          alt="Edit"
        />
        <div class="tool-tip">e-Consent Audit trail</div>
      </span> -->
      <span
        v-if="patient && patient.isRandomized != true"
        class="position-relative cursor-pointer me-2"
        @click="openRandomizationPopup"
      >
        <img
          width="17"
          height="17"
          src="../../assets/img/subject_randomisation.png"
          alt="Edit"
        />
        <div class="tool-tip">Randomization</div>
      </span>
      <!-- v-if="patient && !hasCompletedConsent && !haseconsentcompleted" -->
      <span
        v-if="subjectConsentForms.length == 0"
        class="position-relative cursor-pointer me-2"
        @click.prevent="openModeleconsent(patient.patientId, patient.studyId)"
      >
        <img
          width="17"
          height="17"
          src="../../assets/img/start_e-consent.png"
          alt="Edit"
        />
        <div class="tool-tip">Start Consent</div>
      </span>
      <!-- <span
        v-if="patient && showEConsentButton"
        class="position-relative cursor-pointer me-2"
        @click.prevent="openModeleconsent(patient.patientId, patient.studyId)"
      >
        <img
          width="17"
          height="17"
          src="../../assets/img/start_e-consent.png"
          alt="Edit"
        />
        <div class="tool-tip">Start e-Consent</div>
      </span> -->
      <span
        class="position-relative cursor-pointer me-2"
        @click="openModelaudit"
      >
        <img
          width="17"
          height="17"
          src="../../assets/img/audit_trail_view.png"
          alt="Edit"
        />
        <div class="tool-tip">View Audit trail</div>
      </span>

      <!-- Edit Subject Button-->
      <span class="position-relative cursor-pointer me-5" @click="enableEdit">
        <img
          width="17"
          height="17"
          src="../../assets/img/edit_doc.png"
          alt="Edit"
        />
        <div class="tool-tip">Edit Subject</div>
      </span>
      <span class="tooltip-wrapper cursor-pointer" style="float: right">
        <h2 class="text-primary" @click="closePage()">
          Back
        </h2>
        <!-- <i class="fa fa-times close cursor-pointer" @click="$router.push('/siteuserdashboard')"></i> 
            <span class="custom-tooltip closetooltipposition">Close</span>-->
      </span>
    </div>
  </div>
  <div
    class="d-flex wrapper wrapper-content animated fadeInRight px-0 subject-profile-layout"
  >
    <!-- tiles -->
    <div class="col-lg-12 pl-1 p-0 mt-0">
      <div class="card-body p-0">
        <div class="kpi-tiles">
          <div
            class="kpi-tile kpi-tile-total cursor-pointer d-flex justify-content-between align-items-center mr-2"
            @click.prevent="showtablepopup('', 'Total AEs')"
          >
            <label>Total AEs</label>
            <h3>{{ tilevalues.totalAEs }}</h3>
          </div>

          <div
            class="kpi-tile kpi-tile-total cursor-pointer d-flex justify-content-between align-items-center mr-2"
            @click.prevent="showtablepopup('SEVERE', 'Severe or higher AE')"
          >
            <label>Severe or higher AE</label>
            <h3>{{ tilevalues.grade3PlusAEs }}</h3>
          </div>

          <div
            class="kpi-tile kpi-tile-total cursor-pointer d-flex justify-content-between align-items-center mr-2"
            @click.prevent="showtablepopup('SAE', 'SAEs')"
          >
            <label>SAEs</label>
            <h3>{{ tilevalues.saEs }}</h3>
          </div>
          <div
            class="kpi-tile kpi-tile-total cursor-pointer d-flex justify-content-between align-items-center"
            @click.prevent="showtablepopup('SUSAR', 'SUSAR')"
          >
            <label>SUSAR</label>
            <h3>{{ tilevalues.susaRs }}</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 mt-2 px-0">
      <div class="ibox mb-2" v-if="patient">
        <!-- <div class="ibox-title style_2 d-flex justify-content-between">
          <h5 class="mb-0">Subject Information</h5>      
        </div> -->
        <div class="ibox-content">
          <div class="row">
            <div class="col-md-2 bg-white mt-1 p-2 subject-profile-sidebar">
              <!-- <div class="subject-profile-sidebar__title">Menus</div> -->
              <nav class="subject-profile-sidebar__nav">
                <a :class="decideclass('SoA')" @click="setselectedmenu('SoA')"
                  >SoA</a
                >
                <a
                  :class="decideclass('SubjectOverview')"
                  @click="setselectedmenu('SubjectOverview')"
                  >Subject Overview</a
                >
                <a
                  :class="decideclass('AETimeLine')"
                  @click="setselectedmenu('AETimeLine')"
                  >AE Records</a
                >
                <a
                  :class="decideclass('CMTimeLine')"
                  @click="setselectedmenu('CMTimeLine')"
                  >CM Records</a
                >
                <a
                  :class="decideclass('MHTimeLine')"
                  @click="setselectedmenu('MHTimeLine')"
                  >MH Records</a
                >

                <!-- <a :class="decideclass('SubjectSchedule')" @click="setselectedmenu('SubjectSchedule')">Subject Schedule</a> -->
                <a
                  :class="decideclass('Document')"
                  @click="setselectedmenu('Document')"
                  >Consent Records</a
                >
              </nav>
            </div>
            <div class="col-md-10">
              <div
                class="row"
                v-if="patient && selectedmenu == 'SubjectOverview'"
              >
                <div class="col-lg-12 mt-2">
                  <div class="ibox mb-2">
                    <div class="ibox-content">
                      <div class="compact-grid">
                        <!-- Subject ID + Status in first row (combined for compactness) -->
                        <div class="field">
                          <span class="field-label">Subject ID</span>
                          <span class="field-value" v-if="!isEditMode">{{
                            patient.subjectId
                          }}</span>
                          <input
                            v-else
                            type="text"
                            class="form-control"
                            disabled
                            v-model="editablePatient.subjectId"
                          />
                        </div>

                        <!-- Screening Date-->
                        <div class="field">
                          <span class="field-label">Screening Date</span>
                          <span class="field-value" v-if="!isEditMode">{{
                            formatdatetime(patient.screeningDate)
                          }}</span>
                          <input
                            v-else
                            type="date"
                            class="form-control"
                            v-model="editablePatient.screeningDate"
                          />
                        </div>

                        <!-- Enrolment Date (empty) -->
                        <div class="field">
                          <span class="field-label">Enrolment Date</span>
                          <span
                            class="field-value empty-dash"
                            v-if="!isEditMode"
                            >{{ formatdatetime(patient.enrollmentDate) }}</span
                          >
                          <input
                            v-else
                            type="date"
                            class="form-control"
                            v-model="editablePatient.enrollmentDate"
                          />
                        </div>

                        <!-- Language -->
                        <div class="field">
                          <span class="field-label">Language</span>
                          <span class="field-value" v-if="!isEditMode">{{
                            patient.language
                          }}</span>
                          <select
                            v-else
                            class="form-control"
                            v-model="editablePatient.language"
                          >
                            <option value="" disabled>Select</option>
                            <option
                              v-for="lang in languages"
                              :key="lang.id"
                              :value="lang.language"
                            >
                              {{ lang.language }}
                            </option>
                          </select>
                        </div>

                        <!-- City -->
                        <div class="field">
                          <span class="field-label">City</span>
                          <span class="field-value" v-if="!isEditMode">{{
                            patient.city
                          }}</span>
                          <input
                            v-else
                            type="text"
                            class="form-control"
                            v-model="editablePatient.city"
                          />
                        </div>

                        <!-- Country -->
                        <div class="field">
                          <span class="field-label">Country</span>
                          <span class="field-value" v-if="!isEditMode">{{
                            patient.country
                          }}</span>
                          <select
                            v-else
                            class="form-control"
                            v-model="editablePatient.country"
                          >
                            <option value="" disabled>Select</option>
                            <option
                              v-for="country in countries"
                              :key="country.code"
                              :value="country.name"
                            >
                              {{ country.name }}
                            </option>
                          </select>
                        </div>

                        <!-- Investigator -->
                        <div class="field">
                          <span class="field-label">Investigator</span>
                          <span class="field-value" v-if="!isEditMode">{{
                            patient.nurseName
                          }}</span>
                          <select
                            v-else
                            class="form-control"
                            v-model="editablePatient.nurseName"
                          >
                            <option value="" disabled>Select</option>
                            <option
                              v-for="user in users"
                              :key="user.userID"
                              :value="user.email"
                            >
                              {{ user.name }}
                            </option>
                          </select>
                        </div>
                        <!-- Status-->
                        <div class="field">
                          <span class="field-label">Status</span>
                          <span class="field-value"> </span>

                          <div
                            v-if="!isEditMode"
                            class="d-flex align-items-center gap-2 position-relative cursor-pointer"
                          >
                            <span class="badge badge-grn">{{
                              patient.status
                            }}</span>
                            <i
                              class="fa fa-history text-primary"
                              @click="openStatusAudit('Status')"
                            ></i>
                            <div class="tool-tip">View Status Audit</div>
                          </div>

                          <select
                            v-else
                            class="form-control"
                            v-model="editablePatient.status"
                          >
                            <option
                              v-for="status in statusList"
                              :key="status.id"
                              :value="status.status"
                            >
                              {{ status.status }}
                            </option>
                          </select>
                        </div>

                        <!-- milestone-->
                        <div class="field">
                          <span class="field-label">Milestone</span>
                          <span class="field-value"> </span>

                          <div
                            v-if="!isEditMode"
                            class="d-flex align-items-center gap-2 position-relative cursor-pointer"
                          >
                            <span class="badge badge-grn">{{
                              patient.milestone
                            }}</span>
                            <i
                              class="fa fa-history text-primary"
                              @click="openStatusAudit('Milestone')"
                            ></i>
                            <div class="tool-tip">View Milestone Audit</div>
                          </div>

                          <select
                            v-else
                            class="form-control"
                            v-model="editablePatient.milestone"
                          >
                            <option
                              v-for="mile in milestoneList"
                              :key="mile.id"
                              :value="mile.milestoneName"
                            >
                              {{ mile.milestoneName }}
                            </option>
                          </select>
                        </div>

                        <!-- cohort-->
                        <div class="field">
                          <span class="field-label">Cohort</span>
                          <span class="field-value" v-if="!isEditMode">
                            {{ patient.cohortName ? patient.cohortName : "" }}
                            <span v-if="patient.cohortCode">
                              ({{ patient.cohortCode }})
                            </span>
                          </span>
                          <select
                            v-else
                            class="form-control"
                            v-model="editablePatient.cohortId"
                          >
                            <option value="" disabled>Select</option>
                            <option
                              v-for="cohort in cohortList"
                              :key="cohort.id"
                              :value="cohort.id"
                            >
                              {{ cohort.cohortName }}({{ cohort.cohortCode }})
                            </option>
                          </select>
                        </div>
                        <div class="field">
                          <span class="field-label">Randomized</span>
                          <span class="field-value" v-if="!isEditMode">
                            {{ patient.isRandomized ? "Yes" : "No" }}
                          </span>

                          <!-- Optional edit mode -->
                          <select
                            v-else
                            class="form-control"
                            v-model="editablePatient.isRandomized"
                          >
                            <option :value="true">Yes</option>
                            <option :value="false">No</option>
                          </select>
                        </div>
                        <div class="field" v-if="patient.isRandomized">
                          <span class="field-label">Kit Number</span>
                          <span class="field-value" v-if="!isEditMode">
                            {{ patient.kitNumber }}
                          </span>

                          <input
                            v-else
                            type="text"
                            class="form-control"
                            v-model="editablePatient.kitNumber"
                          />
                        </div>

                        <div class="field" v-if="patient.isRandomized">
                          <span class="field-label">Randomization ID</span>
                          <span class="field-value" v-if="!isEditMode">
                            {{ patient.randomizationId }}
                          </span>

                          <input
                            v-else
                            type="text"
                            class="form-control"
                            v-model="editablePatient.randomizationId"
                          />
                        </div>
                        <div class="field" v-if="patient.isRandomized">
                          <span class="field-label">Randomization Date</span>
                          <span class="field-value" v-if="!isEditMode">
                            {{ formatdatetime(patient.randomizationDate) }}
                          </span>

                          <input
                            v-else
                            type="date"
                            class="form-control"
                            v-model="editablePatient.randomizationDate"
                          />
                        </div>
                            <!-- Screening Failure-->
                        <div class="field">
                          <span class="field-label">Screening Failed</span>
                          <span class="field-value" v-if="!isEditMode"
                            ><input
                              type="checkbox"
                              :checked="patient.isScreeningFailed"
                              disabled
                          /></span>
                          <span class="field-value" v-else
                            ><input
                              type="checkbox"
                              v-model="editablePatient.isScreeningFailed"
                          /></span>
                        </div>

                                              <!-- Consent Signed (read‑only) -->
                        <div class="field">
                          <span class="field-label">Consent Signed</span>
                          <span class="field-value">
                            {{ patient.isConsentSigned ? "Yes" : "No" }}
                          </span>
                        </div>

                        <!-- Signed Date (read‑only) -->
                        <div class="field">
                          <span class="field-label">Signed Date</span>
                          <span class="field-value">
                            {{ formatdatetime(patient.consentSignedDate) || "-" }}
                          </span>
                        </div>

                        <!-- Current ICF Form (read‑only) -->
                        <div class="field">
                          <span class="field-label">Current ICF Form</span>
                          <span class="field-value">
                            {{ patient.currentIcfForm || "-" }}
                          </span>
                        </div>

                        <!-- Current ICF Version (read‑only) -->
                        <div class="field">
                          <span class="field-label">Current ICF Version</span>
                          <span class="field-value">
                            {{ patient.currentIcfVersion || "-" }}
                          </span>
                        </div>

                        <!-- ReConsent Required (read‑only) -->
                        <div class="field">
                          <span class="field-label">ReConsent Required</span>
                          <span class="field-value">
                            {{ patient.reConsentRequired ? "Yes" : "No" }}
                          </span>
                        </div>

                    

                        <!-- Reason for Screening Failure -->
                        <div
                          class="field-full"
                          v-if="
                            isEditMode
                              ? editablePatient.isScreeningFailed
                              : patient.isScreeningFailed
                          "
                        >
                          <span class="field-label mr-2"
                            >Reason for Screening Failure
                            <sup v-if="isEditMode"
                              ><i class="fa fa-asterisk required"></i
                            ></sup>
                          </span>
                          <span class="field-value" v-if="!isEditMode">
                            {{ patient.screeningFailureReason }}</span
                          >
                          <input
                            v-else
                            type="text"
                            class="form-control"
                            v-model="editablePatient.screeningFailureReason"
                          />
                          <small class="errorClass" v-if="screeningError"
                            >Reason is required when screening is marked as
                            failed</small
                          >
                        </div>

                        <!-- Patient Notes (full width) -->
                        <div class="field-full">
                          <span class="field-label mr-2">Patient Notes</span>
                          <span class="field-value" v-if="!isEditMode">{{
                            patient.patientNotes
                          }}</span>
                          <textarea
                            v-else
                            class="form-control"
                            rows="1"
                            v-model="editablePatient.patientNotes"
                          ></textarea>
                        </div>

                        <!-- Buttons -->
                        <div
                          class="field-full d-flex justify-content-end"
                          v-if="isEditMode"
                        >
                          <button
                            class="cancel_btn py-1 px-4"
                            @click="cancelEdit"
                          >
                            Cancel</button
                          >&nbsp;
                          <button
                            class="save_btn py-1 px-4 mr-2"
                            @click="saveEdit"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Table -->
              <div
                v-if="selectedmenu == 'AETimeLine'"
                class="row"
                id="ae-timeline"
              >
                <div class="col-lg-12 pr-1 mb-2 pt-2">
                  <div class="ibox-body">
                    <div
                      class="ibox-title style_2 d-flex justify-content-between"
                    >
                      <h5 class="mt-1">AE REcords</h5>
                    </div>
                    <div class="ibox-content">
                      <div class="table-responsive">
                        <table class="table table-striped table-bordered">
                          <thead>
                            <tr>
                              <th>Sequence No</th>
                              <th class="sort_block" @click="SortSelected('term', 2)" id="2">
      <div class="d-flex flex-row justify-content-between">
        {{ $t("navigations.ae term") }}
        <span>
          <i class="fa fa-long-arrow-up"></i>
          <i class="fa fa-long-arrow-down"></i>
        </span>
      </div>
    </th>
                                                        <th class="sort_block" @click="SortSelected('grade', 3)" id="3">
      <div class="d-flex flex-row justify-content-between">
       Grade
        <span>
          <i class="fa fa-long-arrow-up"></i>
          <i class="fa fa-long-arrow-down"></i>
        </span>
      </div>
    </th>
                              <th class="sort_block" @click="SortSelected('causality', 4)" id="4">
                                <div
                                  class="d-flex flex-row justify-content-between"
                                >
                                  Causality
                                     <span>
          <i class="fa fa-long-arrow-up"></i>
          <i class="fa fa-long-arrow-down"></i>
        </span>
                                </div>
                              </th>
                              <th class="sort_block" @click="SortSelected('serious', 5)" id="5">
                                <div
                                  class="d-flex flex-row justify-content-between"
                                >
                                  Serious
                                     <span>
          <i class="fa fa-long-arrow-up"></i>
          <i class="fa fa-long-arrow-down"></i>
        </span>
                                </div>
                              </th>
                              <th class="sort_block" @click="SortSelected('duration', 6)" id="6">
                                <div
                                  class="d-flex flex-row justify-content-between"
                                >
                                  Duration
                                     <span>
          <i class="fa fa-long-arrow-up"></i>
          <i class="fa fa-long-arrow-down"></i>
        </span>
                                </div>
                              </th>
                              <th class="sort_block" @click="SortSelected('startdate', 7)" id="7">
                                <div
                                  class="d-flex flex-row justify-content-between"
                                >
                                  Start Date
                                     <span>
          <i class="fa fa-long-arrow-up"></i>
          <i class="fa fa-long-arrow-down"></i>
        </span>
                                </div>
                              </th>
                              <th class="sort_block" @click="SortSelected('enddate', 8)" id="8">
                                <div
                                  class="d-flex flex-row justify-content-between"
                                >
                                  End Date
                                     <span>
          <i class="fa fa-long-arrow-up"></i>
          <i class="fa fa-long-arrow-down"></i>
        </span>
                                </div>
                              </th>
                                    <th class="sort_block" @click="SortSelected('outcome', 9)" id="9">
                                <div
                                  class="d-flex flex-row justify-content-between"
                                >
                                  Outcome
                                     <span>
          <i class="fa fa-long-arrow-up"></i>
          <i class="fa fa-long-arrow-down"></i>
        </span>
                                </div>
                              </th>
                              <th>View</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in aetimelineList" :key="item.id">
                              <td>{{ item.sequence }}</td>
                              <td>{{ item.term }}</td>
                              <td>{{ item.grade }}</td>
                              <td>{{ item.causality }}</td>
                              <td>{{ item.serious }}</td>
                              <td>{{ item.duration }}</td>
                              <td>{{ formatdatetime(item.startDate) }}</td>
                              <td>{{ formatdatetime(item.endDate) }}</td>
                              <td>{{ item.outcome }}</td>
                              <td class="text-center">
                                <i
                                  class="fa fa-eye editicon"
                                  @click.prevent="viewforms(item.id)"
                                ></i>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        class="row mx-0 mt-2"
                        v-if="aeTimelineTotalPages > 1"
                      >
                        <div class="col-lg-12 mx-0 px-0">
                          <div
                            class="dataTables_paginate paging_simple_numbers pagination float-right"
                          >
                            <div
                              class="col-lg-12 d-flex justify-content-lg-end px-0"
                            >
                              <v-pagination
                                v-model="aeTimelineCurrentPage"
                                :pages="aeTimelineTotalPages"
                                :range-size="1"
                                active-color="#618bd7"
                                @update:modelValue="loadAeTimelinePage"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- cmtimelinetable -->
              <div
                v-if="selectedmenu == 'CMTimeLine'"
                class="row"
                id="cm-timeline"
              >
                <div class="col-lg-12 pr-1 mb-2">
                  <div class="ibox-body">
                    <div
                      class="ibox-title style_2 d-flex justify-content-between"
                    >
                      <h5 class="mt-1">CM Records</h5>
                    </div>
                    <div class="ibox-content">
                      <div class="table-responsive">
                        <table class="table table-striped table-bordered">
                          <thead>
                            <tr>
                              <th>Medication</th>
                              <th>
                                <div
                                  class="d-flex flex-row justify-content-between"
                                >
                                  Dose
                                </div>
                              </th>
                              <th>Route/Frequency</th>
                              <th>Indication</th>
                              <th>Start Date</th>
                              <th>End Date</th>
                              <th>Status</th>
                              <th>View</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in cmtimelineList" :key="item.id">
                              <td>{{ item.medication }}</td>
                              <td>{{ item.dose }}</td>
                              <td>{{ item.routeFrequency }}</td>
                              <td>{{ item.indication }}</td>
                              <td>{{ formatdatetime(item.startDate) }}</td>
                              <td>{{ formatdatetime(item.endDate) }}</td>
                              <td
                                :class="
                                  item.status == 'Ongoing'
                                    ? 'greenstatus'
                                    : 'redstatus'
                                "
                              >
                                {{ item.status }}
                              </td>
                              <td class="text-center">
                                <i
                                  class="fa fa-eye editicon"
                                  @click.prevent="viewforms(item.id)"
                                ></i>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        class="row mx-0 mt-2"
                        v-if="cmTimelineTotalPages > 1"
                      >
                        <div class="col-lg-12 mx-0 px-0">
                          <div
                            class="dataTables_paginate paging_simple_numbers pagination float-right"
                          >
                            <div
                              class="col-lg-12 d-flex justify-content-lg-end px-0"
                            >
                              <v-pagination
                                v-model="cmTimelineCurrentPage"
                                :pages="cmTimelineTotalPages"
                                :range-size="1"
                                active-color="#618bd7"
                                @update:modelValue="loadCmTimelinePage"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--mhtimeline-->
              <div
                v-if="selectedmenu == 'MHTimeLine'"
                class="row"
                id="mh-timeline"
              >
                <div class="col-lg-12 pr-1 mb-2">
                  <div class="ibox-body">
                    <div
                      class="ibox-title style_2 d-flex justify-content-between"
                    >
                      <h5 class="mt-1">MH Records</h5>
                    </div>
                    <div class="ibox-content">
                      <div class="table-responsive">
                        <table class="table table-striped table-bordered">
                          <thead>
                            <tr>
                              <th>Condition</th>
                              <th>
                                <div
                                  class="d-flex flex-row justify-content-between"
                                >
                                  Duration
                                </div>
                              </th>
                              <th>Start Date</th>
                              <th>End Date</th>
                              <th>Status</th>
                              <th>View</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in mhtimelineList" :key="item.id">
                              <td>{{ item.condition }}</td>
                              <td>{{ item.duration }}</td>
                              <td>{{ formatdatetime(item.startDate) }}</td>
                              <td>{{ formatdatetime(item.endDate) }}</td>
                              <td
                                :class="
                                  item.status == 'Ongoing'
                                    ? 'greenstatus'
                                    : 'redstatus'
                                "
                              >
                                {{ item.status }}
                              </td>
                              <td class="text-center">
                                <i
                                  class="fa fa-eye editicon"
                                  @click.prevent="viewforms(item.id)"
                                ></i>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        class="row mx-0 mt-2"
                        v-if="mhTimelineTotalPages > 1"
                      >
                        <div class="col-lg-12 mx-0 px-0">
                          <div
                            class="dataTables_paginate paging_simple_numbers pagination float-right"
                          >
                            <div
                              class="col-lg-12 d-flex justify-content-lg-end px-0"
                            >
                              <v-pagination
                                v-model="mhTimelineCurrentPage"
                                :pages="mhTimelineTotalPages"
                                :range-size="1"
                                active-color="#618bd7"
                                @update:modelValue="loadMhTimelinePage"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--mhtimeline-->
              <div class="row gx-1">
                <!-- <div
                  v-if="selectedmenu == 'SoA'"
                  class="col-lg-6 pl-1 mt-2"
                  id="soa-section"
                >
                  <SoaTree
                    :subjectId="subjectId"
                    :armCode="patient?.armCode || null"
                    @triggerScheduleRefresh="handleScheduleRefresh"
                  >
                  </SoaTree>
                </div> -->

                <div
                  v-if="selectedmenu == 'SoA'"
                  class="col-lg-12 pl-1 mt-2"
                  id="subject-schedule-section"
                >
                  <SubjectSchedule
                    :subjectId="subjectId"
                    ref="SubjectSchedule"
                  />
                </div>
                <div
                  v-if="selectedmenu == 'Document'"
                  class="row"
                  id="document"
                >
                  <div class="col-lg-12 pr-1 mb-2">
                    <div class="ibox-body">
                      <div
                        class="ibox-title style_2 d-flex justify-content-between"
                      >
                        <h5 class="mt-1">Consent Records</h5>
                      </div>
                      <div class="ibox-content">
                        <!-- Table wrapper with scroll -->
                        <div
                          class="table-responsive"
                          style="max-height: 500px; overflow-y: auto"
                        >
                          <table class="table table-striped table-bordered">
                            <thead
                              style="
                                position: sticky;
                                top: 0;
                                background: white;
                                z-index: 1;
                              "
                            >
                              <tr>
                                <th>Site Code</th>
                                <th>Subject No</th>
                                <th>Consent Type</th>
                                <!-- <th>Phase</th> -->
                                <th>ICF Title</th>
                                <th>Version</th>
                                <th>Language</th>
                                <th>Status</th>
                                <th>Outcome</th>
                                <th>Invited Date</th>
                                <th>Invited By</th>
                                <th>Created Date</th>
                                <th>eCRF Form</th>
                                <th>ICF Form</th>
                                <th>Consent Audit</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(document, index) in subjectConsentForms"
                                :key="document.consentRecordId"
                              >
                                <td>{{ document.siteCode || "-" }}</td>
                                <td>{{ document.subjectNo || "-" }}</td>
                                <td>{{ document.consentType || "-" }}</td>
                                <!-- <td>{{ document.isReConsent ? 'Re-consent' : 'Initial Consent' }}</td> -->
                                <td>{{ document.icf.title || "-" }}</td>
                                <td>{{ document.icf.version || "-" }}</td>
                                <td>{{ document.icf.language || "-" }}</td>
                                <td>{{ document.status || "-" }}</td>
                                <td>{{ document.outcome || "-" }}</td>
                                <td>
                                  {{ formatdatetime(document.createdAt) }}
                                </td>
                                <td>{{ document.createdBy }}</td>
                                <td>
                                  {{ formatdatetime(document.createdAt) }}
                                </td>
                                <td class="text-center">
                                  <i
                                    class="fa fa-eye edit-delete"
                                    @click.prevent="viewICFForm(document)"
                                  ></i>
                                </td>
                                <td class="text-center">
                                  <i
                                    class="fa fa-eye edit-delete"
                                    @click.prevent="
                                      viewConsentdocument(document)
                                    "
                                  ></i>
                                </td>
                                <td class="text-center">
                                  <i
                                    class="fa fa-check-square edit-delete cursor-pointer"
                                    @click.prevent="
                                      openAuditModal(
                                        document.consentRecordId,
                                        document,
                                        index
                                      )
                                    "
                                  ></i>
                                </td>
                              </tr>
                              <tr
                                v-if="
                                  subjectConsentForms.length === 0 &&
                                  !showDocumentLoading
                                "
                              >
                                <td colspan="13" class="text-center">
                                  No consent records found
                                </td>
                              </tr>
                              <tr v-if="showDocumentLoading">
                                <td colspan="13" class="text-center">
                                  <img
                                    src="../../assets/img/loading.gif"
                                    width="20"
                                    alt="Loading..."
                                  />
                                  Loading documents...
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <!-- Pagination Controls -->
                        <div
                          class="row mx-0 mt-3"
                          v-if="consentFormsTotalPages > 1"
                        >
                          <div class="col-lg-12 mx-0 px-0">
                            <div
                              class="dataTables_paginate paging_simple_numbers pagination float-right"
                            >
                              <div
                                class="col-lg-12 d-flex justify-content-lg-end px-0"
                              >
                                <v-pagination
                                  v-model="consentFormsPageIndex"
                                  :pages="consentFormsTotalPages"
                                  :range-size="1"
                                  active-color="#618bd7"
                                  @update:modelValue="loadConsentFormsPage"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Audit trail details modal starts -->
  <div v-if="auditpopup == true" class="audit__details__modal__wrapper">
    <div class="audit__details__modal__container">
      <div
        class="audit__details__modal__title d-flex justify-content-between py-2 px-3"
      >
        <h4 class="my-0">{{ $t("navigations.audit details") }}</h4>
        <div class="cursor-pointer">
          <span class="tooltip-wrapper pointer" style="float: right">
            <i class="fa fa-times" @click.prevent="closemodallll()"></i>
            <span class="custom-tooltip closetooltipposition">Close</span>
          </span>
        </div>
      </div>
      <!-- Popup -->
      <div
        class="audit__details__modal__content p-3"
        :class="{ heightBig: changeHeight }"
      >
        <div class="table-responsive">
          <table class="table table-hover issue-tracker">
            <tbody>
              <tr
                v-for="audit in auditLists"
                :key="audit.studyId"
                class="cursor-pointer"
              >
                <td @click="openModelauditOps(audit.id)">
                  <span class="d-block"
                    ><strong> {{ audit.loggedInUserName }}</strong></span
                  >
                </td>
                <td @click="openModelauditOps(audit.id)">
                  <div>
                    <small>{{ filter(audit.createdAt) }}</small>
                  </div>
                  <div>
                    <small>{{ toTime(audit.createdAt) }}</small>
                  </div>
                </td>
                <td
                  v-if="audit.operation == 'Update'"
                  @click="openModelauditOps(audit.id)"
                >
                  <span class="badge badge-primary">{{ audit.operation }}</span>
                </td>
                <td
                  v-if="audit.operation == 'Delete'"
                  @click="openModelauditOps(audit.id)"
                >
                  <span class="badge badge-danger">{{ audit.operation }}</span>
                </td>
                <td
                  v-if="audit.operation == 'Insert'"
                  @click="openModelauditOps(audit.id)"
                >
                  <span class="badge badge-warning-light">{{
                    audit.operation
                  }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!--  popup -->
  <div class="audit__history__modal__wrapper" v-if="audithistortpopup == true">
    <div class="audit__history__modal__container">
      <div
        class="audit__history__modal__title d-flex justify-content-between py-2 px-3"
      >
        <h4 class="my-0">{{ $t("navigations.audit trail") }}</h4>
        <div class="cursor-pointer" title="Close">
          <i class="fa fa-times" @click.prevent="closehistorymodal()"></i>
        </div>
      </div>
      <!-- test -->

      <!-- Popup -->
      <div class="audit__history__modal__contents p-3">
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>
                  <strong>{{ $t("navigations.field name") }}</strong>
                </th>
                <th>
                  <strong>{{ $t("navigations.old value") }}</strong>
                </th>
                <th>
                  <strong>{{ $t("navigations.new value") }}</strong>
                </th>
              </tr>
              <tr>
                <th>
                  <strong>{{ $t("navigations.subject id") }}</strong>
                </th>
                <td v-if="auditHistoryLists.oldValue">
                  {{ auditHistoryLists.oldValue.SubjectId }}
                </td>
                <td v-else>{{}}</td>
                <td v-if="auditHistoryLists.newValue">
                  {{ auditHistoryLists.newValue.SubjectId }}
                </td>
                <td v-else>{{}}</td>
              </tr>
              <tr>
                <th>
                  <strong>{{ $t("navigations.enrolment date") }}</strong>
                </th>
                <td v-if="auditHistoryLists.oldValue">
                  {{ filter(auditHistoryLists.oldValue.EnrollmentDate) }}
                </td>
                <td v-else>{{}}</td>
                <td v-if="auditHistoryLists.newValue">
                  {{ filter(auditHistoryLists.newValue.EnrollmentDate) }}
                </td>
                <td v-else>{{}}</td>
              </tr>
              <tr>
                <th>
                  <strong>{{ $t("navigations.country") }}</strong>
                </th>
                <td v-if="auditHistoryLists.oldValue">
                  {{ auditHistoryLists.oldValue.Country }}
                </td>
                <td v-else>{{}}</td>
                <td v-if="auditHistoryLists.newValue">
                  {{ auditHistoryLists.newValue.Country }}
                </td>
                <td v-else>{{}}</td>
              </tr>
              <tr>
                <th>
                  <strong>{{ $t("navigations.investigator") }}</strong>
                </th>
                <td v-if="auditHistoryLists.oldValue">
                  {{ auditHistoryLists.oldValue.NurseName }}
                </td>
                <td v-else>{{}}</td>
                <td v-if="auditHistoryLists.newValue">
                  {{ auditHistoryLists.newValue.NurseName }}
                </td>
                <td v-else>{{}}</td>
              </tr>
              <tr>
                <th>
                  <strong>{{ $t("navigations.pre visit") }}</strong>
                </th>
                <td v-if="auditHistoryLists.oldValue">
                  {{ auditHistoryLists.oldValue.PreVisit }}
                </td>
                <td v-else>{{}}</td>
                <td v-if="auditHistoryLists.newValue">
                  {{ auditHistoryLists.newValue.PreVisit }}
                </td>
                <td v-else>{{}}</td>
              </tr>
              <tr>
                <th>
                  <strong>{{ $t("navigations.post visit") }}</strong>
                </th>
                <td v-if="auditHistoryLists.oldValue">
                  {{ auditHistoryLists.oldValue.PostVisit }}
                </td>
                <td v-else>{{}}</td>
                <td v-if="auditHistoryLists.newValue">
                  {{ auditHistoryLists.newValue.PostVisit }}
                </td>
                <td v-else>{{}}</td>
              </tr>
              <tr>
                <th>
                  <strong>{{ $t("navigations.city") }}</strong>
                </th>
                <td v-if="auditHistoryLists.oldValue">
                  {{ auditHistoryLists.oldValue.City }}
                </td>
                <td v-else>{{}}</td>
                <td v-if="auditHistoryLists.newValue">
                  {{ auditHistoryLists.newValue.City }}
                </td>
                <td v-else>{{}}</td>
              </tr>
              <tr>
                <th>
                  <strong>{{ $t("navigations.post/zip code") }}</strong>
                </th>
                <td v-if="auditHistoryLists.oldValue">
                  {{ auditHistoryLists.oldValue.ZipCode }}
                </td>
                <td v-else>{{}}</td>
                <td v-if="auditHistoryLists.newValue">
                  {{ auditHistoryLists.newValue.ZipCode }}
                </td>
                <td v-else>{{}}</td>
              </tr>
              <tr>
                <th>
                  <strong>{{ $t("navigations.language") }}</strong>
                </th>
                <td v-if="auditHistoryLists.oldValue">
                  {{ auditHistoryLists.oldValue.Language }}
                </td>
                <td v-else>{{}}</td>
                <td v-if="auditHistoryLists.newValue">
                  {{ auditHistoryLists.newValue.Language }}
                </td>
                <td v-else>{{}}</td>
              </tr>
              <tr>
                <th>
                  <strong>{{ $t("navigations.subject notes") }}</strong>
                </th>
                <td v-if="auditHistoryLists.oldValue">
                  {{ auditHistoryLists.oldValue.PatientNotes }}
                </td>
                <td v-else>{{}}</td>
                <td v-if="auditHistoryLists.newValue">
                  {{ auditHistoryLists.newValue.PatientNotes }}
                </td>
                <td v-else>{{}}</td>
              </tr>
              <tr>
                <th>
                  <strong>{{ $t("navigations.language code") }}</strong>
                </th>
                <td v-if="auditHistoryLists.oldValue">
                  {{ auditHistoryLists.oldValue.LanguageCode }}
                </td>
                <td v-else>{{}}</td>
                <td v-if="auditHistoryLists.newValue">
                  {{ auditHistoryLists.newValue.LanguageCode }}
                </td>
                <td v-else>{{}}</td>
              </tr>
              <!-- <tr>
                  <th>{{ $t('navigations.language')}}</th>
                  <td>English</td>
                  <td>English</td>
                </tr> -->
              <tr>
                <th>
                  <strong>{{ $t("navigations.active") }}</strong>
                </th>
                <td v-if="auditHistoryLists.oldValue">
                  {{ auditHistoryLists.oldValue.Active }}
                </td>
                <td v-else>{{}}</td>
                <td v-if="auditHistoryLists.newValue">
                  {{ auditHistoryLists.newValue.Active }}
                </td>
                <td v-else>{{}}</td>
              </tr>
            </thead>
          </table>
        </div>
      </div>

      <!-- Modal -->
    </div>
  </div>
  <!-- invite popup -->
  <div class="patient__invite__modal__wrapper" v-if="showInvitePopup">
    <div class="patient__invite__modal__container">
      <div class="modal__title d-flex justify-content-between py-2 px-3">
        <h4 class="my-0 align-self-center">
          {{
            inviteConsentType === "ReConsent"
              ? $t("navigations.start re-consent")
              : $t("navigations.start e-consent")
          }}
        </h4>
        <div
          class="tooltip-wrapper pointer"
          @click.prevent="closeInvitePopup()"
          style="float: right"
        >
          <i class="fa fa-times cursor-pointer"></i>
          <span class="custom-tooltip closetooltipposition">Close</span>
        </div>
      </div>

      <div class="d-flex flex-column p-3">
        <div class="row">
          <div class="col-md-4 invite-left-panel">
            <div class="form-group mb-3">
              <label for="consentFormSelect" class="form-label fw-bold mb-2"
                >Select Consent Form</label
              >
              <select
                id="consentFormSelect"
                v-model="selectedDocumentId"
                class="form-control"
                :class="{ 'is-invalid': inviteFormErrors.selectedDocumentId }"
                @change="onConsentDocumentChange"
                @blur="validateInviteField('selectedDocumentId')"
                @focus="fetchConsentDocuments"
              >
                <option value="" disabled>Select Document</option>
                <option
                  v-for="document in availableICFForms"
                  :key="document.documentId || document.id"
                  :value="document.documentId || document.id"
                >
                  {{ document.formName || document.name || "-" }}
                </option>
              </select>
              <div
                v-if="inviteFormErrors.selectedDocumentId"
                class="error-msg mt-1"
              >
                {{ inviteFormErrors.selectedDocumentId }}
              </div>
            </div>
            <div class="form-group mb-3">
              <label class="form-label fw-bold mb-2">
                Select Consent Type
              </label>

              <div class="form-check">
                <input
                  id="eConsentRadio"
                  type="radio"
                  class="form-check-input"
                  v-model="consentType"
                  checked
                  value="eConsent"
                />
                <label for="eConsentRadio" class="form-check-label">
                  e-Consent
                </label>
              </div>
              <div class="form-check">
                <input
                  id="wetInkRadio"
                  type="radio"
                  class="form-check-input"
                  v-model="consentType"
                  value="Wet Ink"
                />
                <label for="wetInkRadio" class="form-check-label">
                  Wet Ink
                </label>
              </div>
            </div>
            <div v-if="consentType === 'Wet Ink'" class="info-box blue">
              <div class="info-title">
                <i class="fa fa-info-circle"></i> What is Wet Ink consent?
              </div>
              Wet Ink requires the Subject, Investigator, and Witness (optional)
              to physically sign a printed consent form. Follow these steps:
              <ol>
                <li>Print the selected consent form</li>
                <li>
                  Sign the form by Subject, Investigator, and Witness (Optional)
                </li>
                <li>Scan the signed form</li>
                <li>Upload the signed copy below</li>
              </ol>
            </div>
            <div class="form-group mb-3">
              <label for="ecrfFormSelect" class="form-label fw-bold mb-2"
                >Select eCRF Form</label
              >
              <select
                id="ecrfFormSelect"
                v-model="selectedTemplateId"
                class="form-control"
                :class="{ 'is-invalid': inviteFormErrors.selectedTemplateId }"
                @change="onFormChange"
                @blur="validateInviteField('selectedTemplateId')"
              >
                <option value="" disabled>Select Form</option>
                <option
                  v-for="template in eConsentTemplates"
                  :key="template.templateId"
                  :value="template.templateId"
                >
                  {{ template.templateName }} {{ template.version }}
                </option>
              </select>
              <div
                v-if="inviteFormErrors.selectedTemplateId"
                class="error-msg mt-1"
              >
                {{ inviteFormErrors.selectedTemplateId }}
              </div>
            </div>
            <div
              class="form-group mb-3"
              v-if="
                consentType !== 'Wet Ink'
              "
            >
              <label for="inviteEmailInput" class="form-label fw-bold mb-2">
                Email
              </label>

              <input
                id="inviteEmailInput"
                v-model="inviteEmail"
                class="form-control"
                :class="{ 'is-invalid': inviteFormErrors.inviteEmail }"
                type="email"
                placeholder="Enter email address"
                @input="OnUserTypeOnEmailField"
                @blur="validateInviteField('inviteEmail')"
              />

              <div v-if="inviteFormErrors.inviteEmail" class="error-msg mt-1">
                {{ inviteFormErrors.inviteEmail }}
              </div>
            </div>
            <div v-if="consentType === 'Wet Ink'" class="mt-3">
              <!-- Information Box -->

              <!-- Upload Section -->
              <label class="form-label fw-bold mb-2">
                Upload Signed Consent Form
                <span class="text-danger">*</span>
              </label>

              <div class="info-box amber">
                <div class="info-title">
                  <i class="fa fa-warning"></i> Before uploading
                </div>
                Ensure the signed form is legible, all pages are included, and
                the signatures are clearly visible.
              </div>

              <input
                ref="wetInkFile"
                type="file"
                accept=".pdf"
                style="display: none"
                @change="onConsentFileChange"
              />

              <div
                v-if="!uploadedConsentFile"
                class="upload-zone"
                @click="$refs.wetInkFile.click()"
              >
                <i class="fa fa-upload"></i>
                <div class="uz-label">Click to upload signed form</div>
                <div class="uz-sub">PDF</div>
              </div>

              <div
                v-if="uploadedConsentFile"
                class="alert subject-alert-success mt-2 d-flex justify-content-between align-items-center"
              >
                <span>
                  <i class="fa fa-file"></i>
                  {{ uploadedConsentFile.name }}
                </span>

                <i
                  class="fa fa-times cursor-pointer"
                  @click="uploadedConsentFile = null"
                ></i>
              </div>
            </div>
            <!-- <div class="form-group mb-3">
              <label for="inviteEmailInput" class="form-label fw-bold mb-2"
                >Email</label
              >
              <input
                id="inviteEmailInput"
                v-model="inviteEmail"
                class="form-control"
                :class="{ 'is-invalid': inviteFormErrors.inviteEmail }"
                type="email"
                placeholder="Enter email address"
                @input="OnUserTypeOnEmailField"
                @blur="validateInviteField('inviteEmail')"
              />
              <div v-if="inviteFormErrors.inviteEmail" class="error-msg mt-1">
                {{ inviteFormErrors.inviteEmail }}
              </div>
            </div> -->
          </div>

          <div class="col-md-8">
            <div
              class="ecrf-form-view"
              :class="{ 'has-form': selectedTemplateId }"
              style="
                border: 1px solid #dee2e6;
                border-radius: 4px;
                background: #f8f9fa;
                overflow: hidden;
              "
            >
              <div
                class="ecrf-form-header p-2 border-bottom"
                style="background: #e9ecef; font-weight: bold"
              >
                eCRF Form
                <span v-if="selectedFormName" class="text-muted ms-2"
                  >- {{ selectedFormName }}</span
                >
              </div>
              <div
                ref="formContainer"
                class="ecrf-form-body"
                style="height: 400px; overflow-y: auto; padding: 15px"
              >
                <div v-if="selectedTemplateId != ''" class="text-center p-5">
                  <dynamicform
                    ref="inviteDynamicForm"
                    :key="selectedTemplateId + '-' + selectedDocumentId"
                    :templateid="selectedTemplateId"
                    :stdyid="name"
                    :visitids="'0'"
                    :issavefun="true"
                    :requiredvalidate="false"
                    :requiredsubmit="false"
                    :requiredlanguage="false"
                    :subjectid="subjectid"
                    :siteid="patient?.siteId || ''"
                    :fromUrlStatus="urlStatus"
                    :isSigned="signStatus"
                    :autofillfromeconsent="true"
                    :icfid="selectedDocumentId"
                  />
                </div>

                <div v-else class="text-center text-muted p-5">
                  <i class="fa fa-file-text-o fa-3x mb-3"></i>
                  <p class="mb-1">No eCRF Form selected</p>
                  <small
                    >Please select a form from the dropdown to preview</small
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="d-flex justify-content-end gap-2 mt-3"
          v-if="consentType !== 'Wet Ink'"
        >
          <button
            :disabled="isInviting"
            class="save_btn align-self-end py-1 px-3"
            @click.prevent="inviteSubject(inviteConsentType)"
          >
            <span
              v-if="isInviting"
              class="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            <i
              v-if="consentType !== 'Wet Ink'"
              class="fa fa-check px-1 text-white"
            ></i>
            {{ $t("navigations.invite") }}
          </button>
        </div>
        <div
          class="d-flex justify-content-end gap-2 mt-3"
          v-if="consentType === 'Wet Ink'"
        >
          <button
            :disabled="isInviting"
            class="save_btn align-self-end py-1 px-3"
            @click.prevent="inviteSubject(inviteConsentType)"
          >
            <span
              v-if="isInviting"
              class="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            <i v-else class="text-white"></i>
            {{ $t("navigations.submit") }}
          </button>
        </div>

        <div class="error-msg mt-2 px-2 py-1" v-if="err">
          <i class="fa fa-exclamation-circle me-1"></i>
          <b>{{ err }}</b>
        </div>
      </div>
    </div>
  </div>
  <StatusAuditModal
    v-if="showStatusAudit"
    :fieldName="fieldNameForAudit"
    :tableName="tableName"
    :recordId="patientId"
    @close="showStatusAudit = false"
  />
  <!-- Randomization -->
  <RandomizationModal
    v-if="showRandomizationModal"
    :subjectId="ItemID"
    @closeModal="showRandomizationModal = false"
    @refresh="refreshData"
  />
  <!-- Randomization -->
  <customModal
    v-if="showDocumentViewModal"
    :dynamicbodyxl="true"
    :containerxl="true"
    @closeModal="closeDocumentViewModal"
  >
    <template #title> Document Details </template>
    <template #body>
      <div v-if="documentLoading" class="text-center py-5">
        <img src="../../assets/img/loading.gif" width="30" alt="Loading..." />
        <p class="mt-2">Loading document...</p>
      </div>
      <div v-else>
        <!-- Meta Data Section -->
        <div class="row mb-4">
          <div class="col-md-12">
            <h5 class="mb-3">Document Metadata</h5>
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <th style="width: 30%; background-color: #f5f5f5">
                    Document Name
                  </th>
                  <td>{{ currentDocument.name || "-" }}</td>
                </tr>
                <tr>
                  <th style="background-color: #f5f5f5">Document Title</th>
                  <td>{{ currentDocument.documentTitle || "-" }}</td>
                </tr>
                <tr>
                  <th style="background-color: #f5f5f5">Version</th>
                  <td>{{ currentDocument.latestVersion || "-" }}</td>
                </tr>
                <tr>
                  <th style="background-color: #f5f5f5">Owner</th>
                  <td>{{ currentDocument.owner || "-" }}</td>
                </tr>
                <tr>
                  <th style="background-color: #f5f5f5">Created By</th>
                  <td>{{ currentDocument.createdBy || "-" }}</td>
                </tr>
                <tr>
                  <th style="background-color: #f5f5f5">Created Date</th>
                  <td>{{ formatdatetime(currentDocument.createdAt) }}</td>
                </tr>
                <tr>
                  <th style="background-color: #f5f5f5">Description</th>
                  <td>{{ currentDocument.documentDescription || "-" }}</td>
                </tr>
                <tr>
                  <th style="background-color: #f5f5f5">Expiry Date</th>
                  <td>{{ formatdatetime(currentDocument.expiryDate) }}</td>
                </tr>
                <tr>
                  <th style="background-color: #f5f5f5">Status</th>
                  <td>
                    <span
                      :class="
                        currentDocument.status === 'Active'
                          ? 'badge badge-success'
                          : 'badge badge-secondary'
                      "
                    >
                      {{ currentDocument.status || "-" }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Document Preview Section -->
        <div class="row">
          <div class="col-md-12">
            <h5 class="mb-3">Document Preview</h5>
            <div v-if="documentPreviewLoading" class="text-center py-5">
              <img
                src="../../assets/img/loading.gif"
                width="30"
                alt="Loading..."
              />
              <p class="mt-2">Loading document preview...</p>
            </div>
            <div
              v-else-if="documentFormat == 'pdf'"
              class="pdf-embed-container"
            >
              <vue-pdf-embed
                :source="documentSource"
                class="w-100"
                style="height: 600px"
              />
            </div>
            <div
              v-else-if="officeFormats.includes(documentFormat)"
              class="office-preview"
            >
              <iframe
                :src="officePreviewUrl"
                width="100%"
                height="600px"
                frameborder="0"
              ></iframe>
            </div>
            <div
              v-else-if="imageFormats.includes(documentFormat)"
              class="image-preview text-center"
            >
              <img
                :src="documentSource"
                alt="Document Preview"
                class="img-fluid"
                style="max-height: 600px"
              />
            </div>
            <div v-else class="text-center py-5">
              <i class="fa fa-file-o fa-4x text-muted mb-3"></i>
              <p>Preview not available for this file type.</p>
              <a
                :href="documentSource"
                download
                class="btn btn-primary"
                target="_blank"
              >
                <i class="fa fa-download"></i> Download Document
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>
  </customModal>
  <!-- aetablemodel -->
  <aetablemodel
    class="z-2"
    v-if="openaetable"
    :subject-id="subjectId"
    from-page="subjectprofile"
    :aetype="aetype"
    :table-name="aetabletitle"
    @viewform="viewforms"
    @close="closetablepopup"
  />

  <showformmodel
    class="z-3"
    v-if="setshowFormModal"
    :formid="currentform"
    :isedit="true"
    currentformstatus="Completed"
    @closeformModal="closeformModal()"
  />
  <!-- consent audit details modal starts -->
  <!-- <customModal
    v-if="consentauditpopup"
    :containersm="true"
    @closeModal="closemodels()"
  >
    <template #title>
      {{ $t("navigations.e-consent audit trail") }}
    </template>
    <template #body>
      <div class="modal-scroll-body">
        <div
          v-if="consentList.length === 0"
          class="text-muted text-center py-4"
        >
          No consent records found
        </div>

        <div v-else>
          <div
            v-for="consent in consentList"
            :key="consent.id"
            style="margin-bottom: 1rem; cursor: pointer"
            @click="openModelconsentOps(consent.id)"
          >
            <div
              style="display: grid; grid-template-columns: 1fr 1fr; gap: 32px"
            >
              <div>
                <span
                  style="
                    color: #999;
                    font-size: 12px;
                    font-weight: 500;
                    display: block;
                    margin-bottom: 0.25rem;
                  "
                  >Consent Sent By</span
                >
                <span style="color: #333">{{ consent.sentBy }}</span>
              </div>
              <div>
                <span
                  style="
                    color: #999;
                    font-size: 12px;
                    font-weight: 500;
                    display: block;
                    margin-bottom: 0.25rem;
                  "
                  >Consent Generated Date</span
                >
                <span style="color: #333"
                  >{{ formatDate(consent.createdDate) }}
                  {{ formatTime(consent.createdDate) }}</span
                >
              </div>
            </div>

            <div
              style="
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 32px;
                margin-top: 1rem;
              "
            >
              <div>
                <span
                  style="
                    color: #999;
                    font-size: 12px;
                    font-weight: 500;
                    display: block;
                    margin-bottom: 0.25rem;
                  "
                  >Form Viewed By</span
                >
                <span style="color: #333">{{
                  consent.consnetFormViewedBy || "—"
                }}</span>
              </div>
              <div>
                <span
                  style="
                    color: #999;
                    font-size: 12px;
                    font-weight: 500;
                    display: block;
                    margin-bottom: 0.25rem;
                  "
                  >Date Form Viewed</span
                >
                <span style="color: #333">{{
                  consent.consnetFormViewedAt
                    ? formatDate(consent.consnetFormViewedAt) +
                      " " +
                      formatTime(consent.consnetFormViewedAt)
                    : "—"
                }}</span>
              </div>
            </div>

            <div
              style="
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 32px;
                margin-top: 1rem;
              "
            >
              <div>
                <span
                  style="
                    color: #999;
                    font-size: 12px;
                    font-weight: 500;
                    display: block;
                    margin-bottom: 0.25rem;
                  "
                  >Consent Status</span
                >
                <span
                  class="badge"
                  :class="getBadgeClass(consent.consentStatus)"
                  style="display: inline-block"
                  >{{ consent.consentStatus }}</span
                >
              </div>
              <div>
                <span
                  style="
                    color: #999;
                    font-size: 12px;
                    font-weight: 500;
                    display: block;
                    margin-bottom: 0.25rem;
                  "
                  >eSignature Date</span
                >
                <span style="color: #333">{{
                  consent.signedDate
                    ? formatDate(consent.signedDate) +
                      " " +
                      formatTime(consent.signedDate)
                    : "—"
                }}</span>
              </div>
            </div>

            <div
              style="
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 32px;
                margin-top: 1rem;
              "
            >
              <div>
                <span
                  style="
                    color: #999;
                    font-size: 12px;
                    font-weight: 500;
                    display: block;
                    margin-bottom: 0.25rem;
                  "
                  >Investigator Review</span
                >
                <span style="color: #333">{{
                  consent.formVerifiedBy || "—"
                }}</span>
              </div>
              <div>
                <span
                  style="
                    color: #999;
                    font-size: 12px;
                    font-weight: 500;
                    display: block;
                    margin-bottom: 0.25rem;
                  "
                  >Date Investigator Review</span
                >
                <span style="color: #333">{{
                  consent.formVerifiedAt
                    ? formatDate(consent.formVerifiedAt) +
                      " " +
                      formatTime(consent.formVerifiedAt)
                    : "—"
                }}</span>
              </div>
            </div>

            <div
              style="
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 32px;
                margin-top: 1rem;
              "
            >
              <div>
                <span
                  style="
                    color: #999;
                    font-size: 12px;
                    font-weight: 500;
                    display: block;
                    margin-bottom: 0.25rem;
                  "
                  >Audit Completed By</span
                >
                <span style="color: #333">{{
                  consent.markedCompleteBy || "—"
                }}</span>
              </div>
              <div>
                <span
                  style="
                    color: #999;
                    font-size: 12px;
                    font-weight: 500;
                    display: block;
                    margin-bottom: 0.25rem;
                  "
                  >Date Audit Completed</span
                >
                <span style="color: #333">{{
                  consent.completionDate
                    ? formatDate(consent.completionDate) +
                      " " +
                      formatTime(consent.completionDate)
                    : "—"
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </customModal> -->
  <!-- consent audit details modal ends -->
  <!-- consentdocumentauditpopup -->
  <customModal
    v-if="consentdocumentauditpopup"
    :containersm="true"
    @closeModal="closeconsentmodels"
  >
    <template #title>
      <div class="d-flex justify-content-between align-items-center">
        <div><h4 class="mb-0">Consent Audit Trail</h4></div>
      </div>
    </template>

    <template #body>
      <div class="audit-summary py-1">
        <span>{{ auditEvents.length }} events</span>
        <div class="float-right">
          <span class="mr-2">Outcome:</span>
          <span class="audit-status">
            {{ selectedConsentRecord?.outcome || "-" }}
          </span>
        </div>
      </div>

      <div v-if="isLoadingAudit" class="text-center py-1">Loading...</div>

      <div v-else-if="auditEvents.length === 0" class="text-center py-1">
        No audit events found
      </div>

      <div v-else class="audit-event-list">
        <div
          v-for="(ev, index) in auditEvents"
          :key="index"
          class="audit-event-wrapper"
        >
          <!-- Timeline -->
          <div class="audit-timeline">
            <div
              class="audit-icon"
              :style="{
                background: getEventBg(ev.eventType),
              }"
            >
              <i
                :class="getEventIcon(ev.eventType)"
                :style="{
                  color: getEventColor(ev.eventType),
                }"
              ></i>
            </div>

            <div
              v-if="index !== auditEvents.length - 1"
              class="audit-line"
            ></div>
          </div>

          <!-- Content -->
          <div class="audit-content">
            <div class="audit-card">
              <div class="audit-badges">
                <span
                  class="event-badge"
                  :style="{
                    background: getEventBg(ev.eventType),
                    color: getEventColor(ev.eventType),
                  }"
                >
                  {{ ev.message }}
                </span>

                <span class="audit-date">
                  {{ formatDate(ev.eventAt) }}
                  •
                  {{ toTime(ev.eventAt) }}
                </span>

                <span
                  v-if="
                    ev.metadata &&
                    ev.metadata.some(
                      (m) => m.value && m.value.toString().trim() !== ''
                    )
                  "
                  class="audit-metadata-toggle"
                  @click="toggleMetadataExpand(index)"
                >
                  <i
                    :class="[
                      'fa',
                      'fa-chevron-down',
                      { 'metadata-expanded': expandedMetadataIndex === index },
                    ]"
                    style="
                      font-size: 9px;
                      color: var(--color-text-tertiary);
                      flex-shrink: 0;
                    "
                  ></i>
                </span>
              </div>
<!-- 
              <div class="audit-message">
                {{ ev.message }}
              </div> -->

              <div class="audit-user-row">
                <span class="audit-user">
                  {{ ev.userName || "-" }}
                </span>

                <span class="audit-user-type">
                  • {{ ev.userType || "-" }}
                </span>
              </div>
            </div>

            <!-- ADD METADATA CONTENT HERE -->
            <!-- METADATA CONTENT -->
            <div
              v-if="
                ev.metadata &&
                ev.metadata.length > 0 &&
                expandedMetadataIndex === index
              "
              class="audit-metadata-section"
            >
              <div
                v-for="meta in ev.metadata"
                :key="meta.key"
                class="audit-metadata-row"
              >
                <div class="audit-metadata-key">
                  {{ meta.key }}
                </div>

                <div class="audit-metadata-separator">:</div>

                <div class="audit-metadata-value">
                  {{ meta.value || "—" }}
                </div>
              </div>
            </div>
            <!-- ============================================ -->
          </div>
        </div>
      </div>
    </template>
  </customModal>
</template>
<script src="./SubjectProfile.js"></script>
<style scoped>
@import "../../assets/css/style.css";
@import "../../assets/bootstrap.css";
@import "../../assets/font-awesome/css/font-awesome.css";
@import "../../components/subject_tree/tree.css";

/* Status badge */
.badge-grn {
  background-color: #1ab394;
  color: #ffffff;
}
.badge-red {
  background-color: #ff7163;
  color: #ffffff;
}

.subject-profile-layout {
  flex-wrap: wrap;
}

.subject-profile-sidebar {
  position: sticky;
  top: 16px;
  align-self: flex-start;
  border: 1px solid #e9edf4;
}

.subject-profile-sidebar__title {
  font-size: 0.85rem;
  font-weight: 700;
  color: #667286;
  margin-bottom: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.subject-profile-sidebar__nav {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.subject-profile-sidebar__link {
  display: block;
  padding: 0.35rem 0.75rem;
  background-color: #f5f8fc;
  color: #1f2a44;
  font-size: 0.8rem;
  font-weight: 600;
  text-decoration: none;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.subject-profile-sidebar__nav a :active {
  background-color: #f5f8fc;
  color: #4975db;
}

.subject-profile-sidebar__link:hover,
.subject-profile-sidebar__link:focus {
  background-color: #145faf;
  color: #ffffff;
  text-decoration: none;
}
.selectedsubjectmenu {
  background-color: #f5f8fc !important;
  color: #4975db !important;
}

#ae-timeline,
#cm-timeline,
#mh-timeline,
#soa-section,
#subject-schedule-section {
  scroll-margin-top: 20px;
}

@media (max-width: 767px) {
  .subject-profile-sidebar {
    position: static;
    margin-bottom: 0.75rem;
  }
}

/* Scroll area */
.horizondalscroll {
  overflow-y: auto;
  max-height: 500px;
}

/* Flatpickr styling (used inside schedule component) */
:deep(.fp-datetime-input.flatpickr-input),
:deep(.fp-datetime-input.flatpickr-input:focus),
:deep(.fp-datetime-input.flatpickr-input.active) {
  background-color: #ffffff;
  border: 1px solid #e5e6e7;
  border-radius: 1px;
  color: inherit;
  display: block;
  width: 100%;
  min-height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  box-sizing: border-box;
  box-shadow: none;
  outline: none;
}

:deep(.fp-datetime-input.flatpickr-input:focus),
:deep(.fp-datetime-input.flatpickr-input.active) {
  border-color: #145faf;
}

:deep(input.fp-datetime-input.flatpickr-input.active) {
  position: static !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  display: block !important;
}

:deep(.fp-datetime-input.flatpickr-input:disabled) {
  background-color: #e9ecef;
  cursor: not-allowed;
}

/* Audit trail field */
.audit-link {
  color: #4ba5f0;
  cursor: pointer;
  font-weight: 500;
}

.audit-link:hover {
  text-decoration: underline;
  color: #56a0f0;
}
.patient__invite__modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0/18%);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 3000;
}
.error-msg {
  color: #ff0000;
}
.patient__invite__modal__container {
  position: fixed;
  width: min(80%);
  border-radius: 4px;
  background: #fff;
  overflow-x: hidden;
}

.audit__details__modal__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 3000;
}

.audit__details__modal__container {
  width: min(90%, 565px);
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  overflow-y: hidden;
}

.audit__details__modal__title,
.audit__history__modal__title {
  background-color: var(--pop-up-background);
  color: #ffffff;
}

.heightBig {
  overflow-y: scroll;
  height: 250px;
}

.audit__history__modal__contents {
  overflow-y: scroll;
  height: 404px;
}

.audit__history__modal__wrapper {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 4000;
}

.audit__history__modal__container {
  width: min(45%, 90%);
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  overflow-y: hidden;
}

.headingunderline {
  text-decoration-line: underline;
}

.ibox-content .row > div {
  margin-bottom: 12px;
}

.cancel_btn {
  padding: 0.43rem 0.4rem;
  border-radius: 0.25rem;
}
.compact-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem 1rem;
  padding: 0rem;
}
.modal__title {
  background-color: var(--pop-up-background);
  color: hsl(0, 0%, 100%);
}
.save_btn {
  text-align: center;
  background-color: #145faf !important;
  border-color: #145faf !important;
  color: white !important;
  padding: 0.43rem 0.4rem;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out !important;
}

.save_btn:not(:disabled):hover,
.save_btn:focus:focus-visible {
  background-color: #145faf !important;
  border-color: #145faf !important;
}

/* Each field row – very compact */
.field {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  border-bottom: 1px solid #f0f3f8;
  padding: 0.05rem 0;
}
.compact-grid-four {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.5rem 1rem;
  padding: 0rem;
}

.field-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #667286;
  letter-spacing: 0.2px;
  flex-shrink: 0;
  width: 50%;
}

.field-value {
  font-size: 0.8rem;
  font-weight: 500;
  color: #1f2a44;
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  flex-wrap: wrap;
}

.field-full {
  grid-column: span 3;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  border-bottom: 1px solid #f0f3f8;
  padding: 0.05rem 0;
}

.field-full .field-label {
  width: auto;
  flex-shrink: 0;
}

.field-full .field-value {
  text-align: right;
}
.tool-tip {
  top: 24px;
}
.consent-field {
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.consent-field:last-child {
  border-bottom: none;
}

.consent-field label {
  color: #333;
  margin-bottom: 8px;
}

.consent-field p {
  margin: 0;
  color: #666;
}

.consent-details-card {
  background: #f9f9f9;
  padding: 20px;
  border-radius: 4px;
}
.consent-cards-container {
  display: flex;
  flex-direction: column;
}

.consent-card {
  background-color: #f8f9fa;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.consent-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  background-color: #fff;
}

.card-header-section {
  font-size: 1.1rem;
}
.kpi-tiles {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
}
.kpi-tile-total {
  border-color: #ff3c3cab !important;
}

.kpi-tile {
  padding: 12px;
  background: #ffffff;
  border-left: 6px solid;
}
.greenstatus {
  color: #08a532;
  background-color: #82f8a32f;
}
.redstatus {
  color: rgb(255, 0, 0);
  background-color: #f4a1a188;
}
.audit-header {
  background: #0c447c;
  padding: 18px 22px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  color: white;
}

.audit-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
}

.audit-meta {
  display: flex;
  gap: 18px;
  margin-top: 8px;
  flex-wrap: wrap;
  font-size: 12px;
  color: #b5d4f4;
}

.audit-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.audit-status {
  background: #1d9e75;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 600;
  color: #ffffff;
  float: right;
  flex-direction: row;
}

.audit-close {
  border: none;
  background: transparent;
  color: white;
  font-size: 22px;
  cursor: pointer;
}

.audit-summary {
  padding: 14px 22px;
  display: flex;
  gap: 10px;
  border-bottom: 1px solid #e5e5e5;
  font-size: 12px;
  color: #666;
}

.audit-event-list {
  max-height: 500px;
  overflow-y: auto;
  padding: 20px;
}

.audit-event-wrapper {
  display: flex;
  gap: 14px;
}

.audit-timeline {
  width: 34px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.audit-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.audit-line {
  width: 2px;
  flex: 1;
  background: #ddd;
  margin-top: 4px;
}

.audit-content {
  flex: 1;
  padding-bottom: 18px;
}

.audit-card {
  border-radius: 10px;
  padding: 4px 8px;
  transition: 0.2s;
}

.audit-card:hover {
  background: #f8f9fb;
}

.audit-badges {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
}

.event-badge {
  padding: 1px 6px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 600;
}

.audit-date {
  font-size: 11px;
  color: #777;
}

.audit-message {
  margin-top: 4px;
  font-size: 12px;
  color: #222;
}

.audit-user-row {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 2px;
  flex-wrap: wrap;
}

.audit-avatar {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #e6f1fb;
  color: #185fa5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
}

.audit-user {
  font-size: 12px;
  color: #444;
}

.audit-user-type {
  font-size: 11px;
  color: #888;
}

.audit-success {
  margin-left: auto;
  background: #eaf3de;
  color: #3b6d11;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}
.audit-metadata-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 6px;
  margin-top: 2px;
  cursor: pointer;
  user-select: none;
  border-radius: var(--border-radius-md);
  transition: background 0.15s;
  font-size: 12px;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.audit-metadata-toggle:hover {
  background: var(--color-background-secondary);
}

.audit-metadata-toggle i {
  transition: transform 0.2s;
}

.audit-metadata-toggle i.metadata-expanded {
  transform: rotate(180deg);
}

.audit-metadata-section {
  -background: #f8fafc;
  border: 1px solid #e6edf5;
  border-radius: 8px;
  padding: 2px 6px;
  margin-top: 2px;
}
.audit-metadata-row {
  display: flex;
  align-items: flex-start;
  padding: 0px 0;
  border-bottom: 1px solid #eef2f7;
  gap: 7px;
}
.audit-metadata-row:last-child {
  border-bottom: none;
}

.audit-metadata-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 16px;
}

.audit-metadata-item {
  display: flex;
  flex-direction: column;
}

.audit-metadata-key {
  width: 140px;
  min-width: 140px;
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  letter-spacing: 0.04em;
}
.audit-metadata-separator {
  color: #94a3b8;
  font-size: 12px;
  font-weight: 600;
}

.audit-metadata-value {
  flex: 1;
  font-size: 12px;
  font-weight: 500;
  color: #1f2937;
  word-break: break-word;
}
.wet-ink-info {
  border-radius: 8px;
  font-size: 13px;
}

.upload-zone {
  border: 2px dashed #5b9cff;
  border-radius: 8px;
  padding: 25px;
  text-align: center;
  cursor: pointer;
  background: #f5f9ff;
  transition: all 0.2s;
}

.upload-zone:hover {
  background: #edf5ff;
  border-color: #2563eb;
}
.invite-left-panel {
  padding: 20px;
  width: 290px;
  min-width: 290px;
  border-right: 1px solid #e4e9f2;
  background: #fff;
  overflow-y: auto;
  max-height: 440px;
}

/* Optional scrollbar styling */
.invite-left-panel::-webkit-scrollbar {
  width: 6px;
}

.invite-left-panel::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.invite-left-panel::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

.invite-left-panel::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.info-box {
  border-radius: 7px;
  padding: 10px 12px;
  font-size: 12px;
  line-height: 1.65;
  margin-bottom: 14px;
}
.info-box.blue {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  color: #1e40af;
}
.info-box.amber {
  background: #fffbeb;
  border: 1px solid #fcd34d;
  color: #92400e;
}
.info-title {
  font-weight: 600;
  font-size: 12px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  gap: 5px;
}
.info-box ol {
  padding-left: 15px;
  margin-top: 6px;
}
.info-box ol li {
  margin-bottom: 3px;
}
.upload-zone {
  border: 2px dashed #93c5fd;
  border-radius: 8px;
  padding: 16px 12px;
  text-align: center;
  cursor: pointer;
  background: #f0f7ff;
  margin-bottom: 12px;
  transition: background 0.15s;
}
.upload-zone:hover {
  background: #dbeafe;
}
.upload-zone i {
  font-size: 24px;
  color: #2563eb;
  display: block;
  margin-bottom: 6px;
}
.uz-label {
  font-size: 12px;
  color: #1e40af;
  font-weight: 600;
}
.uz-sub {
  font-size: 11px;
  color: #3b82f6;
  margin-top: 3px;
}
.file-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #ecfdf5;
  border: 1px solid #6ee7b7;
  border-radius: 7px;
  padding: 8px 10px;
  font-size: 12px;
  color: #065f46;
  margin-bottom: 12px;
}
.file-badge i {
  color: #059669;
  font-size: 16px;
}
.fb-name {
  flex: 1;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fb-remove {
  cursor: pointer;
  color: #059669;
  font-size: 14px;
}
.fb-remove:hover {
  color: #dc2626;
}
.subject-alert-success {
  color: #0f5132;
  background-color: #ecfdf5;
  border-color: #6ee7b7;
}
</style>
